// removed by extract-text-webpack-plugin
module.exports = {"Card":"_3xO_Ga6CBYNC5NjQLG0F86","Table":"_3oupnIBWpQ3BglGdV34xJT","Row":"XpqiUXF8Yj2qmzZ4tklky","DetailRow":"cpGL9L0g4ATPS5BlftYVX","ResultOk":"rJsoixi6KCzZBjcbAqKHC","ResultBlocked":"_3375NrTmA3bkoPdlvPOO8w","ResultError":"_1G9e9bmQiIOiOggVMGwO1_","Empty":"Exi8YyHpmde6MpmQ3Xde_","DetailTable":"_1SZdbSmoDEtgF09lwEQr0c","DetailLabel":"_35BkHny80JAR0fu1jpO3HD","ProvidersTable":"NEOsjbzhUzDiu5d2LIdAL","PaginationWrap":"_27CykXRHB9QMZFk_MS6bEq","ActiveLink":"_2YeNFlWms33FJ1IBMJOW9V"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/AntiFraudTable/antiFraudTable.module.css
// module id = 526
// module chunks = 0